import { formatText } from "../TruncateParties";
import { WrittenFormat } from "../WrittenFormat";

export const RenderOrders = ({ orders }) => {
  const sortedOrders = orders ? [...orders].sort((a, b) => {
    // Convert DD-MM-YYYY to MM/DD/YYYY for proper Date parsing
    const parseDate = (dateStr) => {
      if (!dateStr) return new Date(0);
      const [day, month, year] = dateStr.split('-');
      return new Date(`${month}/${day}/${year}`);
    };
        
    const dateA = parseDate(a.orderDate);
    const dateB = parseDate(b.orderDate);
        
    return dateB - dateA; // Descending order (newest first)
  }) : [];

  const handlePdfClick = (orderPdfLink) => {
    if (orderPdfLink && orderPdfLink.startsWith('https://')) {
      // Open a blank window with the message
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>PDF Not Available</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  display: flex;
                  justify-content: center;
                  margin: 0;
                  background-color: #f5f5f5;
                }
              </style>
            </head>
            <body>
              <div>
                <h4>Orders pdf is not uploaded for this order</h4>
              </div>
            </body>
          </html>
        `);
        newWindow.document.close();
      }
    } else {
      // Normal case - open the PDF
      window.open(`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${orderPdfLink}`, '_blank');
    }
  };

  return (
    <div className="tab-content">
      {orders && orders.length === 0 ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Orders Found</h3>
          <p className="no-data-message">
            No court orders are available for this case yet.
          </p>
        </div>
      ) : (
        sortedOrders && sortedOrders.map((order, index) => (
          <div key={index} className="order-card">
            <div className="order-det-card">
              <div className="ord-det-card1">
                <p>
                  <strong>Order {order.orderNumber}</strong>
                </p>
                                 
                <p>
                  <strong>Judge:</strong> {formatText(order.judge)}
                </p>
                                 
                {order.orderPdfLink && (
                  <p>
                    <strong>Document: </strong>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePdfClick(order.orderPdfLink);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      View PDF
                    </a>
                  </p>
                )}
              </div>
              <div className="ord-det-card2">
                <p>
                  <strong>Order On:</strong> {order.orderOn}
                </p>
                <p>
                  <strong>Order Date:</strong> {order.orderDate}
                </p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};